import eventRegistration from './eventRegistration/main'
import iFrame from './iFrame/main'
import menu from './menu'
import error from './error'
import cardSelect from './cardSelect'
import core from "./core";
import registrationOverview from "./registrationOverview";

export default {
    eventRegistration,
    menu,
    error,
    cardSelect,
    iFrame,
    registrationOverview,
    core,

    yes: "Ja",
    no: "Nein",

    on: "An",
    off: "Aus",

    day: "Tag",
    month: "Monat",
    year: "Jahr"
}
